import { render } from "./TableOutsideAssignment.vue?vue&type=template&id=607fa79a&scoped=true"
import script from "./TableOutsideAssignment.vue?vue&type=script&lang=js"
export * from "./TableOutsideAssignment.vue?vue&type=script&lang=js"

import "./TableOutsideAssignment.vue?vue&type=style&index=0&id=607fa79a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607fa79a"]])

export default __exports__